import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="page error-bg">
      <div className="error-page">
        <div className="container">
          <div className="my-auto">
            <div className="row align-items-center justify-content-center h-100 text-center">
              <div className="col-xl-7 col-lg-5 col-md-6 col-12">
                <p className="error-text mb-4 text-fixed-white">404</p>
                <p className="fs-4 fw-normal mb-2 text-fixed-white">
                  Page Not Found
                </p>
                <p className="fs-15 mb-5 text-fixed-white">
                  The page you're looking for doesn't exist. Check the URL or
                  return to the homepage.
                </p>
                <Link to={`/`} className="btn btn-primary">
                  <i className="ri-arrow-left-line align-middle me-1 d-inline-block"></i>
                  BACK TO HOME PAGE
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
